import { render } from "./OrderProductStatus.vue?vue&type=template&id=138e87f2"
import script from "./OrderProductStatus.vue?vue&type=script&lang=js"
export * from "./OrderProductStatus.vue?vue&type=script&lang=js"

import "./OrderProductStatus.vue?vue&type=style&index=0&id=138e87f2&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__